import { Alert, Button as AntButton, Form, Modal } from 'antd';
import styled from 'styled-components';

import { Button } from '@components/Button';

type StyledUkBoxProps = {
  isMobileDevice?: boolean;
};

export const StyledUkBox = styled.div<StyledUkBoxProps>`
  padding: ${({ isMobileDevice }) => (isMobileDevice ? '16px' : '0')};

  div.content {
    padding: 20px 24px;
    border: 1px solid ${({ theme }) => theme.palette.stroke[0]};
    border-radius: 4px;
  }
`;

export const StyledStatusUk = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

type StyledButtonsContainerProps = {
  lineHeight?: number;
  color?: string;
};

export const StyledBookedHeader = styled(
  StyledStatusUk
)<StyledButtonsContainerProps>`
  line-height: ${({ lineHeight = 20 }) => lineHeight}px;
  color: ${({ theme, color }) => (color ? color : theme.palette.text[8])};
`;

export const StyledParagraph = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  &.red-text {
    color: ${({ theme }) => theme.palette.color[0]};
  }
  &.bold-text {
    font-weight: 700;
  }

  .bold-text {
    font-weight: 700;
  }
`;

type StyledButtonProps = {
  width?: number;
};
export const StyledButton = styled(Button)<StyledButtonProps>`
  &.ant-btn.ant-btn-default {
    height: 40px;
    border-radius: 5px;
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
    border: 1px solid ${({ theme }) => theme.palette.stroke[0]};
  }
  &.ant-btn.ant-btn-primary {
    height: 40px;
    border-radius: 5px;
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StyledDate = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.text[9]};
`;

export const StyledSnippet = styled.div`
  p:last-child {
    margin: 0;
  }
`;

export const ArchiveAlert = styled(Alert)`
  margin-top: 15px;
  background-color: #ececec;
  border: 1px solid #494949;
  font-size: 12px;
  font-weight: 600;
  height: 49px;
  color: #202020;
`;

export const SubmitToJobName = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 0em;
  color: #000000;
`;

export const ModalTitle = styled.h2`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0em;
  margin-bottom: 16px;
  color: #000000;
`;

export const StyledAvatarContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StyledTitleAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CustomModalContent = styled(Modal)`
  .ant-modal-content {
    padding: 0;
  }

  .css-dev-only-do-not-override-cs932n .ant-modal-content {
    padding: 0;
  }
  .ant-modal-footer {
    margin: 0px;
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    height: auto;
  }
`;

export const WarningIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 22px;
  filter: invert(36%) sepia(80%) saturate(717%) hue-rotate(325deg)
    brightness(105%) contrast(86%);
`;

export const ModalHeader = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  @media (max-width: 576px) {
    font-size: 16px;
    font-weight: 600;
    border: none;
    text-align: center;
  }
`;

export const ModalContent = styled.div`
  width: 100%;
`;

export const JobButton = styled(AntButton)`
  font-size: 14px;
  font-weight: 600;
`;

export const CancelButton = styled(JobButton)<{
  isMobileDevice: boolean;
}>`
  color: #202020;
  ${({ isMobileDevice }) =>
    isMobileDevice &&
    `
      font-size: 16px;
      height: 48px;
    `}

  &:hover {
    color: #6c6c6c !important;
    border-color: ${({ isMobileDevice }) =>
      isMobileDevice ? 'transparent' : '#d9d9d9 !important'};
  }
`;

export const DenyJobButton = styled(JobButton)<{
  isMobileDevice: boolean;
}>`
  border-color: #e14a4a;
  background-color: #e14a4a;
  color: #fcfcfc;
  border-radius: 4px;
  ${({ isMobileDevice }) =>
    isMobileDevice &&
    `
      font-size: 16px;
      height: 48px;
    `}

  &:not(:disabled) {
    &:hover {
      color: #fcfcfc !important;
      border-color: #e14a4ae6 !important;
      background-color: #e14a4ae6 !important;
    }
  }
`;

export const ConfirmDenyModalHeader = styled(ModalHeader)<{
  isMobileDevice: boolean;
}>`
  padding-left: ${(isMobileDevice) => (isMobileDevice ? 0 : '24px')};
  ${({ isMobileDevice }) =>
    isMobileDevice &&
    `
      font-size: 20px;
      line-height: 24px;
      text-align: left;
    `}
`;

export const ConfirmDenyModalContent = styled(ModalContent)<{
  isMobileDevice: boolean;
}>`
  padding-top: 16px;
  padding-left: ${(isMobileDevice) => (isMobileDevice ? 0 : '24px')};
  ${({ isMobileDevice }) => isMobileDevice && 'font-size: 1rem;'}
`;

export const SubmitStyledtext = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  width: 75%;
  word-wrap: break-word;
  color: '#000000';
  @media (max-width: 576px) {
    width: 100%;
    text-align: center;
  }
`;

export const StyledConfirmDenyModal = styled(Modal)<{
  isMobileDevice: boolean;
}>`
  .ant-modal-body {
    padding-left: ${({ isMobileDevice }) => (isMobileDevice ? 0 : '24px')};
  }

  .ant-modal-close {
    display: ${({ isMobileDevice }) =>
      isMobileDevice ? 'none' : 'block'} !important;
  }

  .ant-modal-footer {
    margin-top: 24px;

    ${({ isMobileDevice }) =>
      isMobileDevice &&
      `
        display: flex;
        flex-direction: column-reverse;
        gap: 12px;
        
        button {
          margin-inline-start: 0 !important;
          width: 100%;
        }
      `}
  }

  &.ant-modal {
    width: 90dvw !important;
    max-width: 450px;
  }
`;
